import React, { useState, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Table } from "antd";
import axios from "axios";
import { switchEndpoint } from "../../../../redux/actions/endpoints";
import { toast } from "react-toastify";
import moment from "moment";
import capitalize from "../../../../capitalize";
import { Radio } from "antd";
import "./DriverFilterBar.css";
import DriverModal from "./modals/driversModal";
import { storage } from "../../../../scopedStorage";

const FactoryDrivers = () => {
  const [loading, setLoading] = useState(false);
  const [driversData, setDriversData] = useState([]);
  const [modalInfo, setModalInfo] = useState([]);
  const [vehicleFilter, setVehicleFilter] = useState("all");

  const [showDrop, setShowDrop] = useState(false);
  const handleCloseDrop = () => setShowDrop(false);
  const handleShowDrop = () => setShowDrop(true);

  const safeAddAndFormat = (a, b) => {
    const numA = Number(a) || 0;
    const numB = Number(b) || 0;
    const total = numA + numB;
    return `${total.toFixed(3)}`;
  };


  const columns = [
    {
      title: "ID",
      dataIndex: "key",
      key: "id",
      // sorter: false,
      sorter: (a, b) => a.id - b.id,
      render: (id, record, index) => {
        ++index;
        return index;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "",
      render: (text) => (
        <p className="mb-0" style={{ fontSize: "13px" }}>{`${capitalize(
          text
        )}`}</p>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
      render: (phone) => {
        return (
          <p className="mb-0" style={{ fontSize: "13px" }}>
            {phone}
          </p>
        );
      },
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicle_type",
      key: "vehicle_type",
      render: (text) => (
        <p className="mb-0" style={{ fontSize: "13px" }}>{`${capitalize(
          text
        )}`}</p>
      ),
    },
    {
      title: "Plate Number",
      dataIndex: "vehicle_number",
      key: "vehicle_number",
      render: (vehicle_number) => <p className="mb-0">{`${capitalize(vehicle_number)}`}</p>,
    },

    {
      title: " ",
      key: "action",
      render: (data) => (
        <button
          type="button"
          className="btn loginBtn btn-sm btn-block w-100"
          style={{ fontSize: "13px", fontWeight: "normal" }}
          onClick={() => {
            setModalInfo(data);
            handleShowDrop();
            // console.log(data);
          }}
        >
          Edit Details
        </button>

        // <BsThreeDotsVertical
        //   style={{ cursor: "pointer" }}
        //   onClick={() => {
        //     setModalInfo(data);
        //     handleShowDrop();
        //     // console.log(data);
        //   }}
        // />
      ),
    },
  ];

  const getDriversData = (vehicle_type) => {
    setLoading(true);
    const token = storage.getItem("token");
    axios
      .get(`${switchEndpoint}/factory/drivers?vehicle_type=${vehicle_type}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setDriversData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setVehicleFilter(value);
  };


  useEffect(() => {
    getDriversData(vehicleFilter);
  }, [vehicleFilter]);
  return (
    <main>
      <div className="main__container">
        <div className="driver-filter-bar py-4">
          <div className="driver-filter-left">
            <span className="driver-filter-label">
              Driver <span className="driver-filter-count">({driversData?.length || 0})</span>
            </span>

            <Radio.Group
              value={vehicleFilter}
              onChange={handleChange}
              className="driver-radio-group"
            >
              <Radio value="all">All</Radio>
              <Radio value="tricycle">Tricycle</Radio>
              {/* <Radio value="bus">Bus</Radio> */}
              <Radio value="truck">Truck</Radio>
            </Radio.Group>
          </div>

          <div className="driver-filter-right">
            <button className="link-button">Export Table &gt;</button>
            <button className="link-button">Filter By &gt;</button>
          </div>
        </div>
        {/* <div className="d-flex align-items-center justify-content-between">
          <div>
            <span className="d-flex align-items-center py-3 px-2">
              <b>History</b>({historyData?.length  || 0})
            </span>
          </div>
          <div className="fpw mr-2">
            <p style={{ color: "#231F20", fontSize: "13px" }}>
              Filter By
              <span
                style={{ color: "#c4da00", marginLeft: "5px", width: "10px" }}
              >
                &#62;
              </span>
            </p>
          </div>
        </div> */}
        <Table
          columns={columns}
          dataSource={driversData}
          size="middle"
          pagination={false}
        />
      </div>

      <DriverModal
        showDrop={showDrop}
        handleCloseDrop={handleCloseDrop}
        loading={loading}
        modalInfo={modalInfo}
        setModalInfo={setModalInfo}
      />
    </main>
  );
};

export default FactoryDrivers;
